module.exports = __webpack_public_path__ + "telegram-logo.9d28690cbc96895dc143.png";


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/img/telegram-logo.png
// module id = ../../../../../src/img/telegram-logo.png
// module chunks = 5